<template>
  <div class="messageShow" v-if="showMessage">
    <div :style="`white-space:pre-line;`" class="messageBox">{{ message }}</div>
    <button class="btn btn-success buttonclass" @click="endMessage()">{{ lang.save }}</button>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "showMessage",
  props: {
    message: String,
    clientStatus: String
  },
  data() {
    return {
      showMessage: true,
    }
  },
  computed: {
    lang: function(){
      if(this.$cookies.get(this.$store.state.LangCooki) != null){
        if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
          return this.$store.state.lang.en;
        }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
          return this.$store.state.lang.ur;
        }else{
          return this.$store.state.lang.ar;
        }
      }
      else if(this.$store.state.deflang == 'en'){
        return this.$store.state.lang.en;
      }
      else if(this.$store.state.deflang == 'ur'){
        return this.$store.state.lang.ur;
      }else{
        return this.$store.state.lang.ar;
      }
    },
  },
  methods:{
    async endMessage(){
      let pp = new FormData();
      pp.append('defBranch',localStorage.getItem('defBranch'));
      pp.append('financeYear',localStorage.getItem('financeYear'));
      let type = 'expireMessage';

      pp.append('data[doneIt]','yes');
      pp.append('type',type);
      pp.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
      const response = await axios.post(
          this.$store.state.SAMCOTEC.r_path
          ,pp
      )
      this.showMessage = false;
      if(this.clientStatus != '1')
        this.$router.push({name: 'Home'})
      else{
        this.$cookies.remove(this.$store.state.COOKIEPhase)
      }
    }
  }
}
</script>

<style scoped>
.messageShow{
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom: 0;
  display:flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  background: #FFFFFFDF;
  border:1px solid #000000;
  color:#000000;
}
.messageBox{
  display:flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  width:500px;
  height:250px;
  border: 2px solid #000;
  background: #d7b100;
  padding: 5px;
  text-align:center;
  border-radius: 10px;
}
.buttonclass{
  position:fixed;
  z-index: 1000;
  bottom: 50px;
  left:100px;
}
</style>